export default function relativeTime(start, current) {
  const difference = current - start;
  const msPerMinute = 60 * 1000;
  const msPerHour = 60 * msPerMinute;
  const msPerDay = 24 * msPerHour;
  const msPerMonth = 30 * msPerDay;
  const msPerYear = 12 * msPerMonth;
  if (difference === 0) {
    return 'just now';
  }
  if (difference < msPerMinute) {
    const seconds = Math.round(difference / 1000);
    const suffix = seconds === 1 ? 'second' : ' seconds';
    return `${seconds} ${suffix} ago`;
  }
  if (difference < msPerHour) {
    const minutes = Math.round(difference / msPerMinute);
    const suffix = minutes === 1 ? 'minute' : 'minutes';
    return `${minutes} ${suffix} ago`;
  }
  if (difference < msPerDay) {
    const hours = Math.round(difference / msPerHour);
    const suffix = hours === 1 ? 'hour' : 'hours';
    return `${hours} ${suffix} ago`;
  }
  if (difference < msPerMonth) {
    const days = Math.round(difference / msPerDay);
    const suffix = days === 1 ? 'day' : 'days';
    return `${days} ${suffix} ago`;
  }
  if (difference < msPerYear) {
    const months = Math.round(difference / msPerMonth);
    const suffix = months === 1 ? 'month' : 'months';
    return `${months} ${suffix} ago`;
  }

  const years = Math.round(difference / msPerYear);
  const suffix = years === 1 ? 'year' : 'years';
  return `${years} ${suffix} ago`;
}
